<header class="header">
    <div class="header-grp">
        <div class="icon" (click)="goBackToPrevPage()">
            <i class="ti ti-chevron-left"></i>
        </div>
    </div>
</header>
<main class="p-0">
    <div class="member-info">
        <div class="member-img">
            <div class="profile-details">
                <div class="logo">
                    <div *ngIf="imageUrlApi !== '' ">
                        <img [src]="baseUrl+imageUrlApi" />
                    </div>
                    <div *ngIf="imageUrlApi == '' ">
                        <img src="../../../assets/img/user_.jpg" />
                    </div>
                </div>
            </div>
        </div>

        <div class="personal-info" *ngFor="let data of MemberData;let i=index">
            <h2>{{data.name}}</h2>
            <hr>
            <div class=" table-responsive">
                <table>
                    <tbody>
                        <tr>
                            <td>Mobile No</td>
                            <td colspan="2"></td>
                        </tr>
                        <tr>
                            <th>{{data.contact_no}}</th>
                            <th colspan="2" class="text-success">
                                <a href="{{'https://wa.me/'+data.contact_no}}"> <i class="ti ti-brand-whatsapp"></i></a>
                                <a href="{{'tel:'+data.contact_no}}"><i class="ti ti-phone"></i></a>
                            </th>
                        </tr>
                        <tr>
                            <td>Age</td>
                            <td colspan="2">Blood Group</td>
                        </tr>
                        <tr>
                            <th>{{ data.age }}</th>
                            <th colspan="2">{{data.blood_group}}</th>
                        </tr>
                        <tr>
                            <td colspan="3">Distinction</td>
                        </tr>
                        <tr>
                            <th colspan="3">{{data.education}}</th>
                        </tr>
                        <tr>
                            <td colspan="3">Business</td>
                        </tr>
                        <tr>
                            <th colspan="3">{{data.business}}</th>
                        </tr>
                        <tr>
                            <td>Village</td>
                            <td>Taluka</td>
                            <td>City</td>
                        </tr>
                        <tr>
                            <th>{{data.village_name}}</th>
                            <th>{{data.district_name}}</th>
                            <th>{{data.city_name}}</th>
                        </tr>
                    </tbody>
                </table>
            </div>
            <ng-container *ngIf="i==0">
                <h3>Family Information</h3>
                <div class="main-members" *ngFor="let data of familyMemberList">
                    <div class="member-list-item">
                        <img src="../../../assets/img/user2.webp" />
                        <div>
                            <h5>{{data.name}}</h5>
                            <p>{{data.relation_name}}</p>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>

    </div>
</main>